var paginationThemeWeb = {
  color: 'secondary'
};
var paginationThemeNative = {
  color: 'secondary'
};

export { paginationThemeNative, paginationThemeWeb };
